var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsPricing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.5V16.5C20 16.9028 19.8531 17.2535 19.5594 17.5521C19.2656 17.8507 18.9125 18 18.5 18H5.5C5.09722 18 4.74653 17.8507 4.44792 17.5521C4.14931 17.2535 4 16.9028 4 16.5V7.5C4 7.09722 4.14931 6.74653 4.44792 6.44792C4.74653 6.14931 5.09722 6 5.5 6H18.5C18.9125 6 19.2656 6.14931 19.5594 6.44792C19.8531 6.74653 20 7.09722 20 7.5ZM5.18801 9H18.7899V7.23862H5.18801V9ZM5.23258 11.2252V16.7479H18.7899V11.2252H5.23258Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsPricing);
export default __webpack_public_path__ + "static/media/settings_pricing.502702be5e46fb43222448870e3a6135.svg";
export { ForwardRef as ReactComponent };